import { useCallback, useState } from 'react';

const useLoading = (
  initialValue: boolean,
): [boolean, VoidFunction, VoidFunction] => {
  const [isLoading, setIsLoading] = useState(initialValue);

  const onStartLoading = useCallback(() => {
    setIsLoading(true);
  }, []);

  const onFinishLoading = useCallback(() => {
    setIsLoading(false);
  }, []);

  return [isLoading, onStartLoading, onFinishLoading];
};

export default useLoading;
